import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-test-series-schedule',
  templateUrl: './test-series-schedule.component.html',
  styleUrls: ['./test-series-schedule.component.css']
})
export class TestSeriesScheduleComponent implements OnInit {
examName: any;
  constructor(
    private dialogRef: MatDialogRef<TestSeriesScheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    this.examName = data.examName || "NEET";
  }
  Jeeschedule: any = [
    {dt:"7th August", day: "Sat" },
    {dt:"8th August", day: "Sun" },
    {dt:"11th August", day: "Wed" },
    {dt:"14th August", day: "Sat" },
    {dt:"18th August", day: "Wed" },
    {dt:"21st August", day: "Sat"},
    {dt:"22nd August", day: "Sun" },
    {dt:"23rd August", day: "Mon" },
    {dt:"24th August", day: "Tue" },
    {dt:"25th August", day: "Wed" },
  ]
  ngOnInit(): void {
  }
  closeDialogue() {
    this.dialogRef.close();
  }
}
